import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { User } from '@shared/data-access/data-access-authentication';
import { SHOW_GLOBAL_LOADER } from '@shared/data-access/data-access-ui';
import { isDefined } from '@shared/utils/is-defined.utils';
import { Observable } from 'rxjs';
import { FilterUserRequest } from '../model/user-filter-request.mode';
import { UserImpersonateResponse } from '../model/user-impersonate-response.model';

@Injectable()
export class UserService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  getUsers(payload: FilterUserRequest): Observable<User[] | []> {
    let params = new HttpParams();
    if (payload.search) {
      params = params.set('search', payload.search);
    }

    if (isDefined(payload.pageNumber)) {
      params = params.set('pageNumber', payload.pageNumber);
    }

    if (payload.pageSize) {
      params = params.set('pageSize', payload.pageSize);
    }

    return this.http.get<User[] | []>(`${this.baseUrl}/v1/admin/users`, {
      params,
      context: new HttpContext().set(SHOW_GLOBAL_LOADER, payload.enableGlobalLoader),
    });
  }

  createUser(payload: Partial<User>): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/v1/admin/user`, payload);
  }

  anonymizeUser(id: string): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/v1/admin/users/${id}/anonymize`, null, {
      context: new HttpContext().set(SHOW_GLOBAL_LOADER, true),
    });
  }

  approveUser(id: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/v1/admin/users/${id}/approve`, null, {
      context: new HttpContext().set(SHOW_GLOBAL_LOADER, true),
    });
  }

  rejectUser(id: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/v1/admin/users/${id}/reject`, null, {
      context: new HttpContext().set(SHOW_GLOBAL_LOADER, true),
    });
  }

  updateUser(id: string, payload: User): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/v1/admin/users/${id}`, payload);
  }

  loginAsUser(id: string): Observable<UserImpersonateResponse> {
    return this.http.post<UserImpersonateResponse>(
      `${this.baseUrl}/v1/admin/users/${id}/impersonate`,
      {},
      { context: new HttpContext().set(SHOW_GLOBAL_LOADER, true) },
    );
  }
}
